// Mock data service - data is embedded directly for easy customization
// You can modify the mock data below to fit your needs

import { request } from '@umijs/max';

/** Current user mock data */
const mockCurrentUser = {
  Name: 'Serati Ma',
  Avatar: 'https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png',
  userid: '00000001',
  email: 'antdesign@alipay.com',
  signature: '海纳百川，有容乃大',
  title: '交互专家',
  group: '蚂蚁金服－某某某事业群－某某平台部－某某技术部－UED',
  tags: [
    { key: '0', label: '很有想法的' },
    { key: '1', label: '专注设计' },
    { key: '2', label: '辣~' },
    { key: '3', label: '大长腿' },
    { key: '4', label: '川妹子' },
    { key: '5', label: '海纳百川' },
  ],
  notifyCount: 12,
  unreadCount: 11,
  country: 'China',
  access: 'admin',
  geographic: {
    province: { label: '浙江省', key: '330000' },
    city: { label: '杭州市', key: '330100' },
  },
  address: '西湖区工专路 77 号',
  phone: '0752-268888888',
};

/** Notices mock data */
const mockNotices: API.NoticeIconItem[] = [
  {
    id: '000000001',
    avatar: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/MSbDR4FR2MUAAAAAAAAAAAAAFl94AQBr',
    title: '你收到了 14 份新周报',
    datetime: '2017-08-09',
    type: 'notification',
  },
  {
    id: '000000002',
    avatar: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/hX-PTavYIq4AAAAAAAAAAAAAFl94AQBr',
    title: '你推荐的 曲妮妮 已通过第三轮面试',
    datetime: '2017-08-08',
    type: 'notification',
  },
  {
    id: '000000003',
    avatar: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/jHX5R5l3QjQAAAAAAAAAAAAAFl94AQBr',
    title: '这种模板可以区分多种通知类型',
    datetime: '2017-08-07',
    read: true,
    type: 'notification',
  },
  {
    id: '000000004',
    avatar: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/Wr4mQqx6jfwAAAAAAAAAAAAAFl94AQBr',
    title: '左侧图标用于区分不同的类型',
    datetime: '2017-08-07',
    type: 'notification',
  },
  {
    id: '000000005',
    avatar: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/Mzj_TbcWUj4AAAAAAAAAAAAAFl94AQBr',
    title: '内容不要超过两行字，超出时自动截断',
    datetime: '2017-08-07',
    type: 'notification',
  },
  {
    id: '000000006',
    avatar: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/eXLzRbPqQE4AAAAAAAAAAAAAFl94AQBr',
    title: '曲丽丽 评论了你',
    description: '描述信息描述信息描述信息',
    datetime: '2017-08-07',
    type: 'message',
  },
  {
    id: '000000007',
    avatar: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/w5mRQY2AmEEAAAAAAAAAAAAAFl94AQBr',
    title: '朱偏右 回复了你',
    description: '这种模板用于提醒谁与你发生了互动，左侧放『谁』的头像',
    datetime: '2017-08-07',
    type: 'message',
  },
  {
    id: '000000008',
    avatar: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/wPadR5M9918AAAAAAAAAAAAAFl94AQBr',
    title: '标题',
    description: '这种模板用于提醒谁与你发生了互动，左侧放『谁』的头像',
    datetime: '2017-08-07',
    type: 'message',
  },
  {
    id: '000000009',
    title: '任务名称',
    description: '任务需要在 2017-01-12 20:00 前启动',
    extra: '未开始',
    status: 'todo',
    type: 'event',
  },
  {
    id: '000000010',
    title: '第三方紧急代码变更',
    description: '冠霖提交于 2017-01-06，需在 2017-01-07 前完成代码变更任务',
    extra: '马上到期',
    status: 'urgent',
    type: 'event',
  },
  {
    id: '000000011',
    title: '信息安全考试',
    description: '指派竹尔于 2017-01-09 前完成更新并发布',
    extra: '已耗时 8 天',
    status: 'doing',
    type: 'event',
  },
  {
    id: '000000012',
    title: 'ABCD 版本发布',
    description: '冠霖提交于 2017-01-06，需在 2017-01-07 前完成代码变更任务',
    extra: '进行中',
    status: 'processing',
    type: 'event',
  },
];

/** Generate rule list mock data */
const generateRuleList = (current: number, pageSize: number): API.RuleListItem[] => {
  const list: API.RuleListItem[] = [];
  for (let i = 0; i < pageSize; i += 1) {
    const index = (current - 1) * pageSize + i;
    list.push({
      key: index,
      disabled: i % 6 === 0,
      href: 'https://ant.design',
      avatar: [
        'https://gw.alipayobjects.com/zos/rmsportal/eeHMaZBwmTvLdIwMfBpg.png',
        'https://gw.alipayobjects.com/zos/rmsportal/udxAbMEhpwthVVcjLXik.png',
      ][i % 2],
      name: `TradeCode ${index}`,
      owner: '曲丽丽',
      desc: '这是一段描述',
      callNo: Math.floor(Math.random() * 1000),
      status: Math.floor(Math.random() * 10) % 4,
      updatedAt: new Date().toISOString().split('T')[0],
      createdAt: new Date().toISOString().split('T')[0],
      progress: Math.ceil(Math.random() * 100),
    });
  }
  return list;
};

// Store rule list in memory for CRUD operations
let ruleListData = generateRuleList(1, 100);

// Simulated login state
let currentAccess = 'admin';

/** Logout - clears access */
export async function outLogin(options?: { [key: string]: any }): Promise<Record<string, any>> {
  await new Promise((resolve) => setTimeout(resolve, 100));
  currentAccess = '';
  return { data: {}, success: true };
}

/** Get notices - returns mock data */
export async function getNotices(options?: { [key: string]: any }): Promise<API.NoticeIconList> {
  await new Promise((resolve) => setTimeout(resolve, 100));
  return { data: mockNotices };
}

/** Get rule list - returns paginated mock data */
export async function rule(
  params: {
    current?: number;
    pageSize?: number;
  },
  options?: { [key: string]: any },
): Promise<API.RuleList> {
  await new Promise((resolve) => setTimeout(resolve, 200));

  const { current = 1, pageSize = 10 } = params;
  const start = (current - 1) * pageSize;
  const end = start + pageSize;

  return {
    data: ruleListData.slice(start, end),
    total: ruleListData.length,
    success: true,
  };
}

/** Update rule - updates mock data in memory */
export async function updateRule(options?: { [key: string]: any }): Promise<API.RuleListItem> {
  await new Promise((resolve) => setTimeout(resolve, 200));

  const { key, name, desc } = options || {};
  let updatedRule: API.RuleListItem | undefined;

  ruleListData = ruleListData.map((item) => {
    if (item.key === key) {
      updatedRule = { ...item, name, desc };
      return updatedRule;
    }
    return item;
  });

  return updatedRule || ({} as API.RuleListItem);
}

/** Add rule - adds to mock data in memory */
export async function addRule(options?: { [key: string]: any }): Promise<API.RuleListItem> {
  await new Promise((resolve) => setTimeout(resolve, 200));

  const { name, desc } = options || {};
  const newRule: API.RuleListItem = {
    key: ruleListData.length,
    href: 'https://ant.design',
    avatar: 'https://gw.alipayobjects.com/zos/rmsportal/eeHMaZBwmTvLdIwMfBpg.png',
    name: name || 'New Rule',
    owner: '曲丽丽',
    desc: desc || '新建规则描述',
    callNo: Math.floor(Math.random() * 1000),
    status: 0,
    updatedAt: new Date().toISOString().split('T')[0],
    createdAt: new Date().toISOString().split('T')[0],
    progress: Math.ceil(Math.random() * 100),
  };

  ruleListData.unshift(newRule);
  return newRule;
}

/** Remove rule - removes from mock data in memory */
export async function removeRule(options?: { [key: string]: any }): Promise<Record<string, any>> {
  await new Promise((resolve) => setTimeout(resolve, 200));

  const { key } = options || {};
  if (Array.isArray(key)) {
    ruleListData = ruleListData.filter((item) => !key.includes(item.key));
  } else {
    ruleListData = ruleListData.filter((item) => item.key !== key);
  }

  return {
    list: ruleListData,
    pagination: { total: ruleListData.length },
  };
}
